exports.list = {
    path: '/brand',
    name: 'brand_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/brand/List.vue"),
}
exports.show = {
    path: '/brand/show/:id',
    name: 'brand_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/brand/Show.vue"),
}